import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import Select from 'react-select';
import AppButton from "../layout/AppButton";
import { useUserAdmin } from "../../hooks/useUserAdmin";
import { usePersonaAdmin } from "../../hooks/usePersonaAdmin";
import { useRoleAdmin } from "../../hooks/useRoleAdmin";
import { useToolRoleAdmin } from "../../hooks/useToolRoleAdmin";

const UserRegistration = () => {
    const { registerUser } = useUserAdmin();
    const { fetchPersonaUserGroups } = usePersonaAdmin();
    const { fetchRoles } = useRoleAdmin();
    const { fetchToolRoles } = useToolRoleAdmin();

    const [validated, setValidated] = useState(false);
    const [userType, setuserType] = useState("Member");
    const [EmailAdress, setEmail] = useState("");
    const [isLoading, setIsloading] = useState(false);
    const [issuccess, setsuccess] = useState(false);
    const [iserror, seterror] = useState(false);
    const [iserrorEmail, setiserrorEmail] = useState(false);

    useEffect(() => {
      document.title = "User Registration";
    });
  
    var SelectedList = ["aaysinsight.com"];

    const emailid  = localStorage.getItem("myemail");
    const handleSubmit = (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      var splitArray = EmailAdress.split('@');

      // console.log(form);
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      } 
      else {
       
        if(SelectedList.indexOf(splitArray[1]) >= 0){
          setValidated(true);
          setIsloading(true);
  
          const data = {
            emailAddress: EmailAdress.toLowerCase(),
            userType: userType,
            userGroup:selectedPersona1,
            rlType:selectedOptionsDataRl,
            toolRoleIds:selectedToolRoleIds,
            assignUser:emailid
          }

          registerUser(data)
            .then(function () {
                setIsloading(false)
                setValidated(false)
                setuserType("Member")
                setEmail("")
                setselectedOptionsToolRoles([])
                setSelectedToolRoleIds([])
                setsuccess(true)
                setTimeout(() => {
                  setsuccess(false);
                }, 10000);
                seterror(false);
            })
            .catch(function (error) {
              // console.log(error);
              setIsloading(false);
              setValidated(false);
              setsuccess(false);
              seterror(true);
              setTimeout(() => {
                seterror(false);
              }, 10000);
            });
        }
        else{
          setiserrorEmail(true)
          setTimeout(() => {
            setiserrorEmail(false)
          }, 5000);

        }
       
      }
      setValidated(true);
    };

   
  
   
    const resetForm = (e) => {
      e.preventDefault();
      setValidated(false)
      setuserType("Member")
      setEmail("")
      setSelectedOptions([])
      setselectedOptionsPersona([])
      setselectedOptionsToolRoles([])
      setSelectedToolRoleIds([])
    };

   

    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedOptionsDataRl, setselectedOptionsDataRl] = useState([]);

    const [selectedOptionsPersona, setselectedOptionsPersona] = useState([]);
    const [selectedPersona1, setselectedPersona1] = useState([]);

    const [userGroupMap, setUserGroupMap] = useState({});
    const [userGroupRLSMap, setUserGroupRLSMap] = useState({});
    const [roleOptions, setRoleOptions] = useState([]);

    const [selectedOptionsToolRoles, setselectedOptionsToolRoles] = useState([]);
    const [selectedToolRoleIds, setSelectedToolRoleIds] = useState([]);
    const [toolRoleOptions, setToolRoleOptions] = useState([]);

    const personaOptions = Object.entries(userGroupMap).map(([id, name]) => ({
        value: Number(id),
        label: name,
        reportIncludedRLS: userGroupRLSMap[id] || false,
    }));

    useEffect(() => {
        const fetchUserGroups = async () => {
            try {
                const data = await fetchPersonaUserGroups();
                const map = {};
                const rlsMap = {};
                data.forEach((g) => { 
                    map[g.id] = g.name;
                    rlsMap[g.id] = g.reportIncludedRLS || false;
                });
                setUserGroupMap(map);
                setUserGroupRLSMap(rlsMap);
            } catch (err) {}
        };
        fetchUserGroups();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const fetchRoleOptions = async () => {
            try {
                const data = await fetchRoles();
                setRoleOptions(
                    data.map((r) => ({ value: r.roleName, label: r.roleName }))
                );
            } catch (err) {}
        };
        fetchRoleOptions();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const fetchToolRoleOptions = async () => {
            try {
                const data = await fetchToolRoles();
                setToolRoleOptions(
                    data.map((r) => ({ value: r.toolRoleId, label: r.roleName }))
                );
            } catch (err) {}
        };
        fetchToolRoleOptions();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (selectedOptions) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      setSelectedOptions(selectedOptions)
      const userGroupsArrayRLtype = selectedValues.map((value) => ({ "RLtypename": value }));

      setselectedOptionsDataRl(userGroupsArrayRLtype);

    };

    const handleChangePersona = (selectedOptions) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      setselectedOptionsPersona(selectedOptions)
      const userGroupsArray = selectedValues.map((value) => ({ "userGroupId": value }));

      setselectedPersona1(userGroupsArray);
    };

    const handleChangeToolRoles = (selectedOptions) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      setselectedOptionsToolRoles(selectedOptions)
      const toolRoleIdsArray = selectedValues.map((value) => ({ "toolRoleId": value }));

      setSelectedToolRoleIds(toolRoleIdsArray);
    };
  

    // Check if any selected persona has RLS enabled
    const hasRLSPersona = selectedOptionsPersona.some(
      (persona) => userGroupRLSMap[persona.value] === true
    );

    const canSubmit =
      EmailAdress.trim().length > 0 &&
      !!userType &&
      selectedOptionsToolRoles.length > 0 &&
      selectedOptionsPersona.length > 0 &&
      (hasRLSPersona ? selectedOptions.length > 0 : true);

    // Custom Option Component to display RLS badge
    const PersonaOption = ({ data, innerProps, isSelected, isFocused }) => {
      return (
        <div 
          {...innerProps}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 16px',
            backgroundColor: isFocused ? '#f5f5f5' : (isSelected ? '#bb1ccc' : 'white'),
            color: isSelected ? 'white' : '#333',
            cursor: 'pointer',
            transition: 'all 0.15s ease',
            borderBottom: '1px solid #f0f0f0'
          }}
        >
          <span style={{ fontWeight: isSelected ? '600' : '400' }}>{data.label}</span>
          {data.reportIncludedRLS && (
            <span style={{
              background: isSelected ? 'rgba(255, 255, 255, 0.3)' : '#bb1ccc',
              color: 'white',
              fontSize: '10px',
              fontWeight: 'bold',
              padding: '2px 8px',
              borderRadius: '4px',
              marginLeft: '8px',
              whiteSpace: 'nowrap'
            }}>
              RLS
            </span>
          )}
        </div>
      );
    };
    
  return (
    <div id="userRegId">
       
      <div>
    
          <div id="Create_users_id">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Form.Group as={Col} md="4" controlId="validationCustom01Email">
                  <Form.Label>Email <span style={{ color: '#dc3545' }}>*</span></Form.Label>
                  <Form.Control
                    className="validationCustom01Email"
                    autoComplete="off"
                    required
                    type="email"
                    placeholder="Email Address"
                    value={EmailAdress}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Email Address is required *
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="validationCustom05ToolRoles">
                  <Form.Label>Access Type <span style={{ color: '#dc3545' }}>*</span></Form.Label>

                  <Select
                    options={toolRoleOptions}
                    isMulti
                    required
                    placeholder="Select Tool Roles"
                    value={selectedOptionsToolRoles}
                    onChange={handleChangeToolRoles}
                    className="RlTypesCls"
                  />
                </Form.Group>

                <Form.Group as={Col} md="4" controlId="validationCustom03Pesona">
                  <Form.Label>Persona Type <span style={{ color: '#dc3545' }}>*</span></Form.Label>

                  <Select
                    options={personaOptions}
                    required
                    isMulti
                    placeholder="Select Persona Types"
                    value={selectedOptionsPersona}
                    onChange={handleChangePersona}
                    className="RlTypesCls"
                    components={{ Option: PersonaOption }}
                  />
                  <Form.Control.Feedback type="invalid">
                    Persona Type is required *
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>

              {hasRLSPersona && (
                <Row className="mb-3">
                  <Form.Group as={Col} md="4" controlId="validationCustom04RLType">
                    <Form.Label>Report RLS (If report has RLS) <span style={{ color: '#dc3545' }}>*</span></Form.Label>

                    <Select
                      options={roleOptions}
                      isMulti
                      required
                      placeholder="Select Roles"
                      value={selectedOptions}
                      onChange={handleChange}
                      className="RlTypesCls"
                    />
                    <Form.Control.Feedback type="invalid">
                      Roles is required for personas with RLS *
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
              )}

              <div
                style={{ gridGap: "10px", display: "flex", marginTop: "2rem", justifyContent: "flex-end" }}
                className="mb-3"
              >
               
                <AppButton onClick={resetForm} variant="secondary" type="reset" disabled={isLoading}>
                  Reset
                </AppButton>

                <AppButton disabled={isLoading || !canSubmit} variant="fill" type="submit">
                  
                  {isLoading 
                ? 
                <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span style={{paddingLeft:"10px"}}>Adding...</span>
              </> 

                : "Register User"}
                </AppButton>
              </div>
            </Form>
          </div>
        

        {issuccess && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="success"
            >
              <p className="mb-0">User Successfully Registered</p>
            </Alert>
          </div>
        )}

        {iserror && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="danger"
            >
              <p className="mb-0">
                  User already exists
              </p>
            </Alert>
          </div>
        )}

        {iserrorEmail && (
          <div>
            <Alert
              style={{ position: "absolute", right: "20px", top: "10px" }}
              variant="danger"
            >
              <p className="mb-0">
                Please use '@aaysinsight.com' email id 

              </p>
            </Alert>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserRegistration
